$(function () {
  $('.slider-related-recipes-content').each(function (index, element) {
      const slider = $(element);
      const prevArrow = $('.frecce-slider').eq(index).find('.freccia-prev');
      const nextArrow = $('.frecce-slider').eq(index).find('.freccia-next');
      
      slider.slick({
          dots: false,
          infinite: false,
          slidesToShow: 1.2,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
          responsive: [
              {
                  breakpoint: 640,
                  settings: {
                      slidesToShow: 2
                  }
              },
              {
                  breakpoint: 1024,
                  settings: {
                      arrows: true,
                      slidesToShow: 2.5,
                      prevArrow: prevArrow,
                      nextArrow: nextArrow
                  }
              }
          ]
      });
  });
});
